import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, Container, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";

const PaymentSuccess = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { transactionId, courseName, amount } = location.state || {};
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Format date as "1 June, 2025"
    const formatDate = (date) => {
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        return new Date(date).toLocaleDateString('en-US', options);
    };

    // Transaction Details
    const transactionDetails = [
        { label: "Amount Paid", value: `Rs ${amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` },
        { label: "Course Name", value: courseName },
        { label: "Transaction ID", value: transactionId },
        { label: "Payment Date", value: formatDate(new Date()) },
    ];

    if (!transactionId) {
        navigate('/');
        return null;
    }

    return (
        <Layout>
            <Box className="p-6 bg-gray-100 min-h-screen">
                <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                    <Paper
                        sx={{
                            p: { xs: 2, sm: 4 }, display: "flex", flexDirection: "column",
                            alignItems: "center", borderRadius: 2, minHeight: { xs: 'auto', sm: 860 },
                        }} >
                        <Box sx={{ textAlign: "center", mt: 4 }}>
                            <CheckCircleIcon sx={{ fontSize: { xs: 50, sm: 75 }, color: "#00C853" }} />
                            <Typography variant="h5" sx={{ mt: 2, fontWeight: 600, fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>
                                Payment Successful
                            </Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ mt: 1, px: 2 }}>
                                Your payment has been successfully processed. Thank you for your
                                purchase!
                            </Typography>
                        </Box>

                        <Paper elevation={0}
                            sx={{
                                width: "100%", maxWidth: 960,
                                mt: { xs: 3, sm: 6 }, p: { xs: 2, sm: 4 }, border: "1px solid #dadada", borderRadius: 2,
                            }} >
                            <Typography variant="h6" align="center" gutterBottom sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
                                Transaction Details
                            </Typography>

                            <Box sx={{ maxWidth: 460, mx: "auto", mt: { xs: 2, sm: 4 } }}>
                                {transactionDetails.map((detail, index) => (
                                    <Box key={index}
                                        sx={{
                                            display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1,
                                            borderBottom: index < transactionDetails.length - 1 ? '1px solid #e0e0e0' : 'none'
                                        }} >
                                        <Typography variant="body2" fontWeight={500}>
                                            {detail.label}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {detail.value}
                                        </Typography>
                                    </Box>
                                ))}

                                <Box sx={{ display: "flex", justifyContent: "center", mt: { xs: 3, sm: 6 } }}>
                                    <Button variant="contained" color="primary" onClick={() => navigate('/institute-dashboard')}
                                        startIcon={<ArrowBackIcon />} size={isMobile ? "medium" : "large"}
                                        sx={{ px: { xs: 2, sm: 4 }, py: { xs: 1, sm: 1.5 }, backgroundColor: '#4B49AC' }} >
                                        Back to dashboard
                                    </Button>
                                </Box>
                            </Box>
                        </Paper>
                    </Paper>
                </Container>
            </Box>
        </Layout>
    );
};

export default PaymentSuccess; 